export default __webpack_public_path__ + "static/media/Bracers of the Ravenflight.75f3e219.jpg";